import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgHelp({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16zm-1-8a1 1 0 011-1 1.5 1.5 0 10-1.5-1.5 1 1 0 01-2 0 3.5 3.5 0 114.5 3.355V14a1 1 0 01-2 0v-2zm1 6.5a1 1 0 110-2 1 1 0 010 2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgHelp
